<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/KgXD4b/tc-custom/9780857909824.jpg?1718183455201" alt="This image is the cover for the book Moscow Calling"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Moscow Calling
      </h1>
      <p class="bookDescription body article font2">
        <b>A British journalist offers an intimate view of Russia from the Cold War to the rise of Putin through his personal experiences as a correspondent.</b><br/>  <br/> In the course of the past 45 years, Angus Roxburgh has translated Tolstoy, met four successive Russian presidents and been jinxed by a Siberian shaman. He has come under fire in war zones and been arrested by Chechen thugs. During the Cold War he was wooed by the KGB, who then decided he would make a lousy spy and expelled him from the country. In <i>Moscow Calling</i>, Roxburgh presents his Russia: not the Russia of news reports, but a quirky, exasperating, beautiful, tumultuous world that in four decades has changed completely—and not at all.<br/>  <br/> Roxburgh narrates an incredible journey from the dark, fearful days of communism and his adventures as a correspondent covering the Soviet Union’s collapse to his frustrating work as a media consultant to Putin’s Kremlin. His memoir offers a unique, fascinating and at times hilarious insight into a country that today, more than ever, is of global political significance.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Angus Roxburgh
      </h2>
      
      <p class="authorDescription body article">Angus Roxburgh studied Russian and German at Aberdeen University. A distinguished journalist and broadcaster, he was Sunday Times Moscow correspondent (1987-89), BBC Moscow correspondent (1991-97) and BBC Europe correspondent (1998-2005). From 2006-2009 he was media consultant to the Kremlin, and is now a freelance writer and journalist. He is the author of the acclaimed The Strongman: Vladimir Putin and the Struggle for Russia and was consultant on the award-winning BBC documentaries, The Second Russian Revolution, and Putin, Russia and the West.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Birlinn
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?db415ff8